module.exports = __webpack_public_path__ + "img/dollar-watch.15ebc7c6.svg";